export const DATE_FORMAT = 'yyyy-MM-dd';
export const DATE_WITH_TIME_FORMAT = 'yyyy-MM-dd, HH:mm';

export const DEFAULT_LOCALE = 'en-us';

export const EMPTY_FUNCTION = () => {};
